import React from 'react';
// import PropTypes from 'prop-types';
import logo from '../../../img/logo-gray.svg';
import './ReportFooter.css';


const ReportFooter = (props) => {
    return (
        <section className="report-footer">
            <img src={logo} alt="footer logo yoganosh" className="report-footer__logo"/>
            <p className="report-footer__desc">© 2018 Yoganosh. All rights reserved.<br/>For your information only. Yoganosh does not provide medical or nutritional advice, treatment or diagnosis.</p>
        </section>
    )
}

export default ReportFooter;


// WEBPACK FOOTER //
// ./src/components/Report/ReportFooter/ReportFooter.js